export default {
  title: 'Noch keine Daten vorhanden',
  employees: {
    couriers: {
      title: 'Es sind noch keine Außendienst-Mitarbeiter im System',
      subtitle: 'Fügen Sie neue Mitarbeiter hinzu!',
    },
    managers: {
      title: 'Noch keine Gebietsleiter im System',
      subtitle: 'Fügen Sie neue Mitarbeiter hinzu!',
    },
    admins: {
      title: 'Noch keine Admins im System',
      subtitle: 'Fügen Sie neue Mitarbeiter hinzu!',
    },
  },
  journeys: {
    title: 'Noch keine Tätigkeiten im System dokumentiert',
  },
  routes: {
    title: 'Noch keine Rayone im System',
    subtitle: 'Bitte fügen Sie neue Rayone hinzu',
  },
  leaves: {
    title: 'Noch keine Abwesenheiten im System',
  },
}
